import type { CSSProperties, MouseEvent, ReactNode } from 'react';
import { cn } from '@shared/utils';

const IconColorsEnum = {
  Inherit: 'inherit',
  Primary: 'primary',
  Secondary: 'secondary',
  SecondaryInverse: 'secondary-inverse',
  White: 'white',
  Light: 'light',
  Black: 'black',
  Red: 'red',
  Green: 'green',
  Yellow: 'yellow',
  Dark: 'dark',
} as const;
export type IconColorsEnum = (typeof IconColorsEnum)[keyof typeof IconColorsEnum];

interface IconProps {
  icon: ReactNode;
  className?: string;
  style?: CSSProperties;
  color?: IconColorsEnum;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const Icon = (props: IconProps) => {
  return (
    <div
      className={cn(
        !props.color && 'text-slate dark:text-white',
        props.color === IconColorsEnum.Inherit && 'text-inherit',
        props.color === IconColorsEnum.Primary && 'text-primary',
        props.color === IconColorsEnum.Secondary && 'text-primary dark:text-soft-black',
        props.color === IconColorsEnum.SecondaryInverse && 'text-soft-black dark:text-primary',
        props.color === IconColorsEnum.White && 'text-white',
        props.color === IconColorsEnum.Light && 'text-light',
        props.color === IconColorsEnum.Black && 'text-soft-black',
        props.color === IconColorsEnum.Red && 'text-red',
        props.color === IconColorsEnum.Green && 'text-green',
        props.color === IconColorsEnum.Yellow && 'text-[#E3E69D]',
        props.color === IconColorsEnum.Dark && 'text-slate dark:text-white/70',
        props.className,
      )}
      style={props.style}
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      {props.icon}
    </div>
  );
};
